import * as Sentry from '@sentry/vue';
import { getActivePinia } from 'pinia';

/**
 * Reset every instantiated Pinia store, bar the ones named in `except`.
 *
 * Options stores get `$reset` from Pinia; a setup store has to return its own. `notifications`
 * isn't a Pinia store, so it is outside the registry and its callers clear it themselves.
 */
export function resetStores({ except = [] }: { except?: string[] } = {}): void {
  const pinia = getActivePinia();
  if (!pinia) {
    return;
  }

  for (const [id, store] of pinia._s) {
    if (except.includes(id)) {
      continue;
    }

    try {
      store.$reset();
    } catch (err) {
      // Setup stores only get a working `$reset` when they define one themselves.
      console.error(`Failed to reset the "${id}" store, it needs to implement $reset()`, err);
      Sentry.captureException(err);
    }
  }
}
